module.exports = __webpack_public_path__ + "static/Rudbeckia hirta (Black-eye Susan)-86ee47a8e9972490ac44467f0a4cd00e.jpg";